/**
 * Custom navigation script for sticky header with custom thresholds for desktop and mobile
 * This script allows the header to become sticky at specified scroll positions (in vh)
 */
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('store-header');
  const mainHeader = document.querySelector('header');
  const body = document.body;
  
  if (!header) return;
  
  const logoScaleDesktop = header.getAttribute('logo-scale-desktop') || 0.7;
  const logoScaleMobile = header.getAttribute('logo-scale-mobile') || 0.7;
  const menuIconsScaleDesktop = header.getAttribute('menu-icons-scale-desktop') || 0.8;
  const menuIconsScaleMobile = header.getAttribute('menu-icons-scale-mobile') || 0.85;
  
  document.documentElement.style.setProperty('--logo-scale-desktop', logoScaleDesktop);
  document.documentElement.style.setProperty('--logo-scale-mobile', logoScaleMobile);
  document.documentElement.style.setProperty('--menu-icons-scale-desktop', menuIconsScaleDesktop);
  document.documentElement.style.setProperty('--menu-icons-scale-mobile', menuIconsScaleMobile);
  
  const firstSection = document.querySelector('.shopify-section:first-child [allow-transparent-header]');
  
  if (header.hasAttribute('custom-sticky-enabled')) {
    const mainElement = document.querySelector('main');
    if (mainElement) {
      const firstSectionInsideMain = mainElement.querySelector('.shopify-section:first-child');
      
      if (firstSectionInsideMain) {
        if (firstSectionInsideMain.classList.contains('shopify-section--slideshow')) {
          body.classList.add('white-nav');
        } 
        else if (firstSectionInsideMain.classList.contains('shopify-section--main-product') || 
                 firstSectionInsideMain.querySelector('.shopify-policy__container')) {
          body.classList.add('blue-nav');
        }
      }
    }
    
    const desktopThresholdVh = parseFloat(header.getAttribute('custom-sticky-threshold-desktop') || 100);
    const mobileThresholdVh = parseFloat(header.getAttribute('custom-sticky-threshold-mobile') || 100);
    
    const isMobile = () => window.innerWidth < 768;
    
    const calculateThreshold = () => {
      const thresholdVh = isMobile() ? mobileThresholdVh : desktopThresholdVh;
      return (window.innerHeight * thresholdVh) / 100;
    };
    
    let threshold = calculateThreshold();
    let lastScrollTop = 0;
    let stickyActive = false;
    let scrollingDown = true;
    let pausedAboveThreshold = false;
    
    window.addEventListener('resize', () => {
      threshold = calculateThreshold();
      checkScrollPosition();
    });
    
    const checkScrollPosition = () => {
      const scrollY = window.scrollY;
      
      scrollingDown = scrollY > lastScrollTop;
      
      if (scrollY <= 100) {
        if (stickyActive) {
          //console.log('Deactivating sticky header near top');
          stickyActive = false;
          mainHeader.classList.remove('is-custom-sticky-active');
          header.classList.remove('header--small');
          header.removeAttribute('custom-sticky-active');
          pausedAboveThreshold = false;
        }
      } 
      else if (scrollY < threshold) {
        if (scrollingDown && pausedAboveThreshold) {
          if (stickyActive) {
            //console.log('Deactivating sticky header - scrolling down after pause');
            stickyActive = false;
            mainHeader.classList.remove('is-custom-sticky-active');
            header.classList.remove('header--small');
            header.removeAttribute('custom-sticky-active');
          }
        }
        pausedAboveThreshold = true;
      }
      else if (scrollY >= threshold) {
        if (!stickyActive) {
          //console.log('Activating sticky header');
          stickyActive = true;
          mainHeader.classList.add('is-custom-sticky-active');
          header.classList.add('header--small');
          header.setAttribute('custom-sticky-active', '');
        }
        pausedAboveThreshold = false;
      }
      
      lastScrollTop = scrollY;
    };
    
    window.addEventListener('scroll', throttle(checkScrollPosition, 50));
    window.addEventListener('touchmove', throttle(checkScrollPosition, 50));
    
    checkScrollPosition();
    setTimeout(checkScrollPosition, 100);
  } else if (header.hasAttribute('sticky')) {
    let lastScrollTop = 0;
    let stickyActive = false;
    
    const checkStandardStickyScroll = () => {
      const scrollY = window.scrollY;
      
      if (scrollY <= 100) {
        if (stickyActive) {
          stickyActive = false;
          header.classList.remove('header--small');
        }
      } else if (scrollY > 300) {
        if (!stickyActive) {
          stickyActive = true;
          header.classList.add('header--small');
        }
      }
      
      lastScrollTop = scrollY;
    };
    
    window.addEventListener('scroll', throttle(checkStandardStickyScroll, 50));
    window.addEventListener('touchmove', throttle(checkStandardStickyScroll, 50));
    
    checkStandardStickyScroll();
    setTimeout(checkStandardStickyScroll, 100);
  }
});

function throttle(callback, delay) {
  let previousCall = 0;
  return function(...args) {
    const now = Date.now();
    if (now - previousCall >= delay) {
      previousCall = now;
      callback.apply(this, args);
    }
  };
}